import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function JoinSuccess() {
  useParams<{ tenantId: string }>();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');

  useEffect(() => {
    // Fire the Google Analytics conversion — this is the event Atlas's intake
    // flow swallowed, so Google Ads can finally attribute dues revenue.
    // (gtag is a no-op until the tenant's GA Measurement ID is injected.)
    window.gtag?.('event', 'purchase', { transaction_id: sessionId ?? undefined });
  }, [sessionId]);

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-b from-background to-muted/40 px-6">
      <div className="max-w-md text-center">
        <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
        <h1 className="mt-4 text-3xl font-bold tracking-tight">You're a member!</h1>
        <p className="mt-3 text-muted-foreground">
          Thanks for joining. A welcome email is on its way and a team member will be in touch shortly.
        </p>
        {sessionId && <p className="mt-6 font-mono text-xs text-muted-foreground">ref: {sessionId.slice(0, 24)}…</p>}
      </div>
    </div>
  );
}
